// Returns the height of given element in pixels, incluing margin, padding, and border
export function getAbsoluteHeight(el: HTMLElement): number {
  const styles = window.getComputedStyle(el);
  const margin =
    parseFloat(styles['marginTop']) + parseFloat(styles['marginBottom']);

  return Math.ceil(el.offsetHeight + margin);
}

// Returns the width of given element in pixels, incluing margin, padding, and border
export function getAbsoluteWidth(el: HTMLElement): number {
  const styles = window.getComputedStyle(el);
  const margin =
    parseFloat(styles['marginLeft']) + parseFloat(styles['marginRight']);

  return Math.ceil(el.offsetWidth + margin);
}
